var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 18.125C14.9034 18.125 18.625 14.4034 18.625 9.8125C18.625 5.22163 14.9034 1.5 10.3125 1.5C5.72163 1.5 2 5.22163 2 9.8125C2 14.4034 5.72163 18.125 10.3125 18.125Z",
    stroke: "#02215F",
    strokeWidth: 2.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42188 5.0625C8.39831 5.0625 7.41666 5.46911 6.69288 6.19288C5.96911 6.91666 5.5625 7.89831 5.5625 8.92188M21 20.5L17.1406 16.6406",
    stroke: "#02215F",
    strokeWidth: 2.57292,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7a390eb8eb1cbd1cbe6743c20797927b.svg";
export { ForwardRef as ReactComponent };